<template>
  <div :class="classes"
       class="calendar-item">
    <span class="date">
      {{ formatDate }}
    </span>

    <span v-if="data !== null"
          class="text">
      {{ data }}
    </span>
  </div>
</template>

<script>
export default {
  name: "CalendarItem",
  props: {
    day: {
      type: Number,
      default: null
    },
    month: {
      type: Number,
      default: null
    },
    data: {
      type: Number,
      default: null
    },
    odd: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * Method used to compute the classes based on the current day hours.
     */
    classes () {
      const result = [];

      if ( this.odd ) {
        result.push( "odd" );
      }

      if ( this.selected ) {
        result.push( "selected" );
      }

      if ( this.data !== null ) {
        result.push( "has-data" );
      }

      return result;
    },

    /**
     * Method used to format the day and month values.
     */
    formatDate () {
      const result = `${`${this.day}`.padStart( 2, "0" )}`;
      return result;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../Styles/utils/colors.less";

.calendar-item {
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: gray;
  background: #E3F3EA;

  &.odd {
    background: #F0F9F4;
  }

  &.selected {
    .text {
      @scale-size: 1.2;

      background: @color-accent-6-dark;
      color: #fff;
      transform: scale3d( @scale-size, @scale-size, @scale-size );
    }
  }

  &.has-data {
    cursor: pointer;
  }
}

.date {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-start;
  position: absolute;
  top: 4px;
  left: 4px;
  font-size: 11px;
  font-weight: 600;
  transition: font-size .2s;
  background: #fff;
  min-width: 23px;
  height: 23px;
  border-radius: 100px;
  z-index: inherit;
  color: #000;

  @media screen and ( max-width: 600px ) {
    font-size: 10px;
    top: 2px;
    left: 2px;
    min-width: 15px;
    height: 15px;
    font-weight: 500;
  }
}

.text {
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 100px;
  font-size: 25px;
  font-weight: 500;
  transition: font-size .2s, transform .2s, background-color .2s;
  background: #017C7F;
  color: #fff;
  align-items: center;
  justify-content: center;
  z-index: 999;

  @media screen and ( max-width: 500px ) {
    margin-top: 11px;
    height: 28px;
    width: 28px;
    font-weight: 400;
    z-index: inherit;
    font-size: 16px;
  }
}

</style>
